<template>
  <div class="step-one">
    <h2 class="text-h6 mb-4">{{ $t('onboarding.step1.description') }}</h2>

    <v-form ref="form" v-model="valid">
      <v-text-field
        v-model="form.companyName"
        :label="companyNameLabel + ' *'"
        :rules="[rules.required]"
        outlined
        dense
        required
      ></v-text-field>

      <!-- Organization-specific fields -->
      <template v-if="isOrganization">
        <v-text-field
          v-model="form.siret"
          :label="$t('siret')"
          outlined
          dense
        ></v-text-field>

        <v-text-field
          v-model="form.vatNumber"
          :label="$t('vat-number')"
          outlined
          dense
        ></v-text-field>
      </template>

      <!-- Address -->
      <v-divider class="my-4"></v-divider>
      <h3 class="text-subtitle-1 mb-2">{{ $t('address') }} *</h3>

      <v-text-field
        v-model="form.address.street"
        :label="$t('street') + ' *'"
        :rules="[rules.required]"
        outlined
        dense
      ></v-text-field>

      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="form.address.city"
            :label="$t('city') + ' *'"
            :rules="[rules.required]"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="form.address.zipcode"
            :label="$t('zipcode') + ' *'"
            :rules="[rules.required]"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>

      <available-select
          class="mb-6"
        v-model="form.address.country"
        :label="$t('country')"
        type="country"
        :filter="country => ['FR', 'BE', 'NL', 'DK', 'LU', 'GB', 'DE', 'ES', 'IT', 'CH', 'AT', 'PT', 'IE', 'PL', 'CZ', 'SE', 'NO', 'FI'].includes(country.code)"
        outlined
        dense
      ></available-select>

      <v-text-field
        v-model="form.phone"
        :label="$t('phone')"
        outlined
        dense
      ></v-text-field>

    </v-form>

    <div class="d-flex justify-end mt-6">
      <v-btn
        color="primary"
        small
        :loading="loading"
        :disabled="!valid"
        @click="handleNext"
      >
        {{ $t('next') }}
        <v-icon right small>mdi-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import AvailableSelect from '@blocks/Select/AvailableSelect.vue'

export default {
  name: 'StepOne',

  components: {
    AvailableSelect
  },

  props: {
    enrollment: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      valid: false,
      form: {
        companyName: '',
        siret: '',
        vatNumber: '',
        phone: '',
        address: {
          street: '',
          city: '',
          zipcode: '',
          country: 'FR'
        }
      },
      rules: {
        required: v => !!v || this.$t('rules.field-required')
      }
    }
  },

  computed: {
    isOrganization() {
      return this.enrollment?.type === 'organization'
    },

    companyNameLabel() {
      // For customers, we use a more generic label
      // For organizations, we use "Company name"
      if (this.enrollment?.type === 'customer') {
        return this.$t('full-name')
      }
      return this.$t('company-name')
    }
  },

  watch: {
    enrollment: {
      immediate: true,
      handler(val) {
        if (val) {
          // For customers, default companyName to firstName + lastName if not set
          if (val.type === 'customer' && !val.companyName && (val.firstName || val.lastName)) {
            this.form.companyName = [val.firstName, val.lastName].filter(Boolean).join(' ')
          } else {
            this.form.companyName = val.companyName || ''
          }

          this.form.siret = val.siret || ''
          this.form.vatNumber = val.vatNumber || ''
          this.form.phone = val.phone || ''

          const enrollmentAddress = val.address || {}
          this.form.address.street = enrollmentAddress.street || ''
          this.form.address.city = enrollmentAddress.city || ''
          this.form.address.zipcode = enrollmentAddress.zipcode || ''
          this.form.address.country = enrollmentAddress.country || 'FR'
        }
      }
    }
  },

  methods: {
    handleNext() {
      if (this.$refs.form.validate()) {
        this.$emit('next', this.form)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.step-one {}
</style>
